export default __webpack_public_path__ + "static/media/partial-mask.b6ce82a0.svg";